import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiAuth, baseUrl } from '../api';
import { logout } from '../redux';
import { fetchAuthSession } from 'aws-amplify/auth';

export const fetchBaseQueryAuth = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers) => {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString() || ''; // Отримання токена доступу

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await fetchBaseQueryAuth(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    const data = await fetchAuthSession({ forceRefresh: true });
    if (data) {
      result = await fetchBaseQueryAuth(args, api, extraOptions);
    } else {
      api.dispatch(logout());
    }
  }
  return result;
};

type AxiosBaseQueryProps = {
  url: string;
  method: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  headers?: AxiosRequestConfig['headers'];
  timeout?: AxiosRequestConfig['timeout'];
};

export const axiosBaseQuery = async ({
  url,
  method,
  data,
  headers,
  timeout,
}: AxiosBaseQueryProps) => {
  try {
    const obj: { [key: string]: any } = {
      get: apiAuth.get,
      post: apiAuth.post,
      put: apiAuth.put,
      delete: apiAuth.delete,
    };

    const meth = method || 'get';

    const result = await obj[meth](url, data, { headers, timeout });
    return { data: result.data };
  } catch (axiosError) {
    const err = axiosError as AxiosError;
    return {
      error: { status: err.response?.status, data: err.response?.data },
    };
  }
};
